export default "__VITE_ASSET__DlkC$47n__"